import { KYMW0800Model } from './../kymw0800.model';
import { PlessURL } from '../../../../shared/pless-url';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 実績履歴登録クラス
 *
 * @export PdfFileCopyService
 * @class PdfFileCopyService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class PdfFileCopyService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0800Model;
  private fileName: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof PdfFileCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PdfFileName: this.fileName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof PdfFileCopyService
   */
  execute(model: KYMW0800Model, fileName: string, successFunc: Function = null): void {
    this.model = model;
    this.fileName = fileName;
    this.successFunc = successFunc;
    this.send('KYMW0800PdfFileCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof PdfFileCopyService
   */
  success(data: any): void {
    // 'CopyComplete'の場合、ファイルリクエスト
    if (data.CopyResult === 'CopyComplete') {

      this.model.kymw0800Component.navigateURLUtilService.navigateToURL(data.CopyUrl, '_blank', 'width=800,height=600');

    } else if (data.CopyResult === 'ConnectFailed') {
      // エラー処理
      // E0164メッセージ表示
      this.dialogService.openAlertGetMessage('E0164', ['不正なFTP接続情報', 'FTPサーバーに接続']);

    } else if (data.CopyResult === 'FileNotExist') {
      // エラー処理
      // E0129メッセージ表示
      this.dialogService.openAlertGetMessage('E0129', ['該当するPDF']);
    }
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
